'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var validFilterValues = ['today', 'this_week', 'this_month', 'this_year', 'last_7_days', 'last_30_days', 'last_90_days', 'last_365_days', 'all_time'];
var DashboardPerformanceFilter = Joi__default["default"].object().keys({
  filter: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, validFilterValues).required().description('The performance filter value the creator is viewing')
}).description('dashboard:performance_filter event attributes ').meta({
  name: 'DashboardPerformanceFilter',
  filename: 'dashboard:performance_filter.model'
});
var DashboardPerformanceFilter$1 = DashboardPerformanceFilter;

module.exports = DashboardPerformanceFilter$1;
//# sourceMappingURL=performance_filter.model.js.map
